import SimpleReactValidator from "simple-react-validator";
import {
  DropDownDTO,
  QuestionChoiceDTO,
  StandardQuestionUploadDTO,
} from "../../../common/types/common.dto.types";

/* ==============================|| VIEWS - PAGES - BULK UPLOAD QUESTIONS PAGE - TYPES ||==============================  */

export interface BulkQuestionUploadPageParametersType {
  StandardId: number;
  StandardName: string;
}

export interface BulkQuestionUploadPageType {
  StandardId: number;
  UploadedFileName: string;
  StandardQuestionReviewList: Array<StandardQuestionUploadDTO>;
  BulkQuestionTypeList: Array<DropDownDTO>;
  BulkQuestionCategoryDropdownList: Array<DropDownDTO>;
  BulkQuestionCategoryChoiceList: Array<QuestionChoiceDTO>;
  Validator: SimpleReactValidator;
  PageNavigation: PageNavigationType;
  BulkQuestionUploadPageMode: EnumBulkQuestionUploadPageMode;
  ShowCategoryChoicesValidationMsg: boolean;
}

export interface PageNavigationType {
  EnablePageNavigation: boolean;
  NavigationPage: string;
}

export enum EnumBulkQuestionUploadPageMode {
  UploadQuestionMode = 1,
  ValidateQuestionMode = 2,
  ReviewQuestionMode = 3,
}
